module.exports = __webpack_public_path__ + "django.6c8118.svg";